import { axiosInstance as axios } from "services";

export const deleteSeriesType = async (id) => {
  const { data } = await axios.delete(`/pricing/master/labor/${id}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to delete labor");
  return data;
};

